import { Tag, ClosableTag, TagProps, ClosableTagProps } from "@packages/ds";

export { Tag, ClosableTag };
export type { TagProps, ClosableTagProps };

// For backward compatibility with existing imports
// This ensures old code importing the default export still works
const TagForBackwardCompatibility = Tag;
export default TagForBackwardCompatibility;
